<template>
  <div class="d-flex flex-column" style="height: 100%">
    <!-- Bộ lọc -->
    <div class="pa-4">
      <Breadcrumbs
        :headline="$route.meta.title"
        :link="[
          {
            text: $route.meta.title,
          },
        ]"
      />
    </div>
    <v-card class="pa-6 mb-6 mx-4 elevation-0" outlined>
      <v-row dense>
        <v-col cols="4">
          <v-text-field v-model="filters.creator_name" label="Tên người giao việc" dense outlined hide-details="auto" />
        </v-col>
        <v-col cols="4">
          <v-text-field
            v-model="filters.receiver_name"
            label="Tên người nhận việc"
            dense
            outlined
            hide-details="auto"
          />
        </v-col>
        <v-col cols="4">
          <v-select
            v-model="filters.status"
            :items="statusOptions"
            label="Trạng thái"
            dense
            outlined
            clearable
          ></v-select>
        </v-col>

        <v-col cols="12" class="d-flex justify-end">
          <v-btn outlined color="primary" @click="fetchReport">Tìm kiếm</v-btn>
        </v-col>
      </v-row>
    </v-card>

    <!-- Bảng báo cáo -->
    <v-card outlined class="mx-4 elevation-0">
      <v-data-table
        :headers="headers"
        :items="reportData"
        :loading="isLoading"
        loading-text="Đang tải báo cáo..."
        item-key="user_id"
        @click:row="openTaskDetail"
      >
        <template v-slot:item.name_creator="{ item }">
          <span class="text--primary font-weight-medium">{{ item.name_creator }}</span>
        </template>

        <template v-slot:item.name_receiver="{ item }">
          <span style="color: #2196f3" class="font-weight-medium">{{ item.name_receiver }}</span>
        </template>

        <template v-slot:item.taskProgress="{ item }">
          <span>{{ item.completedTasks }}/{{ item.totalTasks }}</span>
        </template>
        <template v-slot:item.progressRate="{ item }">
          <v-chip :color="rateColor(item.progressRate)" dark small> {{ item.progressRate }}% </v-chip>
        </template>
      </v-data-table>
    </v-card>
    <TaskNewReportDetail
      :state="detailDialog"
      :receiverId="selectedReceiverId"
      :receiverName="selectedReceiverName"
      @close="detailDialog = false"
    />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import TaskNewReportDetail from '@/modules/task-new/TaskNewReportDetail.vue'

export default {
  components: {
    Breadcrumbs,
    TaskNewReportDetail,
  },
  data() {
    return {
      creator_name: '',
      receiver_name: '',
      isLoading: false,
      filters: {
        creator_name: '',
        receiver_name: '',
        status: null,
      },
      reportData: [],
      detailDialog: false,
      selectedReceiverId: null,
      selectedReceiverName: '',
      statusOptions: [
        { text: 'Chưa bắt đầu', value: 'not_started' },
        { text: 'Đang thực hiện', value: 'in_progress' },
        { text: 'Hoàn thành', value: 'completed' },
        { text: 'Chờ đánh giá', value: 'waiting' },
      ],
      headers: [
        { text: 'Người nhận việc', value: 'name_receiver' },
        { text: 'Người giao việc', value: 'name_creator' },
        { text: 'Công việc (Hoàn thành/Tổng)', value: 'taskProgress' },
        { text: 'Tỷ lệ hoàn thành', value: 'progressRate' },
      ],
    }
  },
  async mounted() {
    await this.fetchReport()
  },
  methods: {
    async fetchReport() {
      this.isLoading = true
      try {
        // Giả lập API call lấy dữ liệu
        const response = await this.$store.dispatch('tasknew/fetchTaskReport', this.filters)
        console.log('response', response)
        this.reportData = response.data.map(user => ({
          ...user,
          progressRate: user.totalTasks === 0 ? 0 : Math.round((user.completedTasks / user.totalTasks) * 100),
        }))
      } catch (err) {
        this.$alert.error('Không thể tải báo cáo')
      } finally {
        this.isLoading = false
      }
    },
    resetFilters() {
      this.filters = {
        creator_name: '',
        receiver_name: '',
        status: null,
      }
      this.reportData = []
    },
    rateColor(rate) {
      if (rate >= 80) return 'green'
      if (rate >= 50) return 'orange'
      return 'red'
    },
    openTaskDetail(item) {
      this.selectedReceiverId = item.user_id
      this.selectedReceiverName = item.name_receiver
      this.detailDialog = true
    },
  },
}
</script>

<style scoped></style>
